import { useMutation } from '@apollo/client'
import { ADMIN_ACTIVATE_ACCOUNT_MUTATION } from '@graphql'

const useActivateAccount = () => {
  const [activateAccount] = useMutation(ADMIN_ACTIVATE_ACCOUNT_MUTATION)

  const activate = ({ userId, password, onSuccess, onError, update }) => {
    return activateAccount({
      variables: {
        input: {
          user_id: userId,
          password: password,
          password_confirmation: password,
        },
      },

      onCompleted: (data) => {
        if (onSuccess) onSuccess(data)
      },

      onError: (error) => {
        if (onError) onError(error)
      },
      
      update: (cache, { data: { adminActivateAccount } }) => {
        if (update) update(cache, adminActivateAccount)
      },
    })
  }

  return { activate }
}

export default useActivateAccount